document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.card-novelty').forEach(function (el) {
    if (el.innerText.trim() === '' || el.innerText.trim() === '\u00A0') {
      el.style.display = 'none';
    }
  });
});




/* Bypass regle CSS pour la pop up fete des mères (largeur du bouton) */
console.log("custom.js chargé");

const applyDirectInlineStyle = () => {
  const host = document.querySelector('#popupsmart-container-225008');
  if (!host || !host.shadowRoot) return false;

  const shadow = host.shadowRoot;
  const btn = shadow.getElementById("button-d9p3qneiz6o0");
  if (!btn) return false;

  // Réinitialisation complète du style en JS
  btn.style.setProperty("width", "fit-content", "important");
  btn.style.setProperty("min-width", "auto", "important");
  btn.style.setProperty("max-width", "none", "important");

  console.log("✅ Style inline modifié avec !important");
  return true;
};

let attempts = 0;
const maxAttempts = 20;
const interval = setInterval(() => {
  const success = applyDirectInlineStyle();
  attempts++;
  if (success || attempts >= maxAttempts) clearInterval(interval);
}, 300);

console.log("🔎 width actuel : ", btn.style.width);